import React from 'react';
import classnames from 'classnames';
import Text from '../../Text/Text';
import Fade from '../../Transitions/Fade/Fade';

import './Textarea.scss';

export interface TextareaProps {
    /**
     * Ref input
     */
    ref?: any;
    /**
     * Id attr textarea
     */
    id?: string;
    /**
     * Name attr textarea
     */
    name: string;
    /**
     * Placeholder attr textarea
     */
    placeholder?: string;
    /**
     * Label attr textarea
     */
    label?: string;
    /**
     * Error message
     */
    error?: string;
    /**
     * Material style
     * @default false
     */
    material?: boolean;
    /**
     * Read only
     * @default false
     */
    readonly?: boolean;
    /**
     * Disabled
     * @default false
     */
    disabled?: boolean;
    /**
     * Align text
     */
    align?: 'left' | 'right' | 'center';
    /**
     * Resize textarea attr
     * @default 'none'
     */
    resize?: 'none' | 'both' | 'horizontal' | 'vertical' | 'initial' | 'inherit';
    /**
     * Rows textarea attr
     * @default 3
     */
    rows?: number;
    /**
     * Class name styles
     */
    className?: string;
    /**
     * Textarea class name styles
     */
    textareaClassName?: string;
    /**
     * Style
     */
    style?: any;
    /**
     * Value Textarea
     */
    value?: string | number;
    /**
     * Function called on change Textarea
     */
    onChange?(event?: any): any;
    /**
     * Other props
     */
    [otherProps: string]: any;
}

const Textarea: React.FC<TextareaProps> = React.forwardRef(
    (
        {
            id,
            name,
            label,
            placeholder,
            error,
            disabled = false,
            material = false,
            readonly = false,
            align = 'left',
            resize = 'none',
            rows = 3,
            className,
            textareaClassName,
            style,
            value,
            onChange = () => {},
            ...otherProps
        },
        ref
    ) => {
        const classNames = classnames(['textarea', { disabled }, className]);
        const TextareaClassNames = classnames([
            'textarea__textarea',
            { disabled, readonly, error: !!error, material },
            align,
            textareaClassName,
        ]);
        const handleChange = (event: any) => onChange({ ...event, value: event?.target?.value });

        return (
            <div className={classNames} style={style}>
                {label && !material && (
                    <Text tag="label" typo="label" for={id} className="textarea__label">
                        {label}
                    </Text>
                )}
                <div className="textarea__wrapper">
                    <textarea
                        ref={ref}
                        id={id}
                        name={name}
                        value={value}
                        rows={rows}
                        placeholder={material ? label : placeholder}
                        disabled={disabled}
                        className={TextareaClassNames}
                        style={{ resize }}
                        onChange={handleChange}
                        {...otherProps}
                    />
                    {label && material && (
                        <Text tag="label" typo="label" weight="medium" for={id} className="textarea__label--material">
                            {label}
                        </Text>
                    )}
                </div>
                {!!error && (
                    <Fade>
                        <Text tag="span" size="12" color="error" className="textarea__error">
                            {error}
                        </Text>
                    </Fade>
                )}
            </div>
        );
    }
);

export default Textarea;
